import clsx from "clsx";
import styles from "./WithheldTabButton.module.scss";

const WithheldTabButton = ({
  isActive,
  onClick,
  children,
}: {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <button
    className={clsx(
      "border-0 bg-transparent px-3 py-1 outline-none",
      styles.withheldTab,
      isActive && styles.activeTab,
    )}
    type="button"
    onClick={onClick}
  >
    {children}
  </button>
);

export default WithheldTabButton;
